// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Cormorant Garamond', 'Cormorant Garamond Fallback'","fontStyle":"normal"},"className":"__className_ee4d97"};